import { Link } from "react-router-dom";
import { collection, orderBy, query, limit } from "firebase/firestore";
import { useFirestoreCollection } from "../../lib/useFirestoreCollection";

export default function Dashboard() {
  const { items: projects } = useFirestoreCollection(
    "projects",
    orderBy("updatedAt", "desc"),
    limit(5)
  );
  const { items: portfolio } = useFirestoreCollection(
    "portfolio",
    orderBy("year", "desc"),
    limit(5)
  );

  return (
    <section>
      <span className="mono-tag">// 00 — Dashboard</span>
      <h1
        style={{
          fontSize: "var(--step-3)",
          fontWeight: 300,
          letterSpacing: "-0.025em",
          marginTop: "0.5rem",
          marginBottom: "2rem",
        }}
      >
        Panel de <strong>Aya Tech</strong>
        <span style={{ color: "var(--color-accent)" }}>.</span>
      </h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <Card
          to="/admin/hero"
          title="Imágenes del Hero"
          desc="Subir/cambiar la imagen del Hero pública."
        />
        <Card
          to="/admin/portafolio"
          title="Casos del portafolio"
          desc="Mostrar los proyectos destacados en la home."
        />
        <Card
          to="/admin/proyectos"
          title={`Repositorio (${projects.length})`}
          desc="Máquinas con galería + fichas, manuales y planos."
        />
      </div>

      <section style={{ marginTop: "3rem" }}>
        <h2 style={{ fontSize: "var(--step-1)", marginBottom: "0.75rem" }}>
          Últimos cambios
        </h2>
        <ul style={{ display: "grid", gap: "0.4rem" }}>
          {[...projects, ...portfolio]
            .slice(0, 6)
            .map((it) => (
              <li
                key={it.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0.5rem 0",
                  borderBottom: "1px dashed var(--color-line)",
                  fontSize: "var(--step--1)",
                  color: "var(--color-ink-soft)",
                }}
              >
                <span>{it.name || it.title || it.id}</span>
                <span className="mono-tag">{it.id.slice(0, 6)}</span>
              </li>
            ))}
          {projects.length + portfolio.length === 0 && (
            <li className="mono-tag">// aún no hay actividad</li>
          )}
        </ul>
      </section>
    </section>
  );
}

function Card({ to, title, desc }) {
  return (
    <Link
      to={to}
      style={{
        display: "block",
        padding: "1.25rem",
        border: "1px solid var(--color-line)",
        background: "var(--color-bg)",
        transition: "border-color var(--t-base), transform var(--t-base)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "var(--color-accent)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "var(--color-line)";
        e.currentTarget.style.transform = "none";
      }}
    >
      <h3 style={{ fontSize: "var(--step-1)", marginBottom: "0.4rem" }}>{title}</h3>
      <p style={{ color: "var(--color-ink-soft)", fontSize: "var(--step--1)" }}>{desc}</p>
    </Link>
  );
}
